import { getLanguage } from '@/utils/language'

const language = getLanguage()

// 是否是中文
export const isZh = ['hans', 'hant'].includes(language)

// 用户协议
export const USER_AGREEMENT = `https://support.tapon.com/user_agreement_${isZh ? `zh_${language}` : language}.html`

// 隐私政策
export const PRIVACY_POLICY = `https://support.tapon.com/privacy_policy_${isZh ? `zh_${language}` : language}.html`

// 深度链接
export const DEEP_LINK = 'https://link.tapon.com/9LZM'
